import * as React from 'react';

import cn from 'classnames';

import { noop } from '@utils';

import { IFormProps } from './types';

import * as s from './Form.scss';

export class Form extends React.Component<IFormProps> {

	static defaultProps: Partial<IFormProps> = {
		onSubmit: noop,
	};

	onSubmit = (event: React.FormEvent) => {
		event.preventDefault();

		this.props.onSubmit(event);
	};

	render() {
		const { className } = this.props;

		return (
			<form
				className={cn(s.block, className)}
				onSubmit={this.onSubmit}
			>
				{this.props.children}
			</form>
		);
	}

}
